import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import transactionComponent from './transaction.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let transactionModule = angular.module('transaction', [
  uiRouter,
  modal,
  datepickerPopup,
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider.state('quickbooks-transaction', {
    parent: 'app',
    url: '/admin/integrations/quickbooks/transaction',
    data: {
      pageHeader: true,
      pageTitle: 'Quickbooks Transaction Capability',
      pageDesc: '',
      breadcrumbLink: 'quickbooks',
      breadcrumbText: 'Quickbooks Capabilities'
    },
    template: '<transaction></transaction>'
  })

})

.component('transaction', transactionComponent);

export default transactionModule;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/transaction/transaction.js